import React from 'react'
import styles from './icnStyleSwitcher.module.scss'
import classNames from 'classnames'
export interface Style {
  key: string
  icon: React.ReactElement
}

interface Props {
  onSelect: (string) => void
  heading: string
  selected: Style
  selections: Style[]
  classIconActive?: string
  classIconInactive?: string
}

const IcnStyleSwitcher: React.FC<Props> = ({
  onSelect,
  heading,
  selections,
  selected,
  classIconActive,
  classIconInactive,
}) => {
  return (
    <div className={styles.stylesSwitcher}>
      <div className={styles.stylesSwitcherInner}>
        <h3 className={styles.heading}>{heading}</h3>
        <div className={styles.btnsWrapper}>
          {selections.map(s => (
            <button key={s.key} onClick={() => onSelect(s.key)} className={styles.styleSelector}>
              <span
                className={classNames(styles.icon, {
                  [classIconActive || styles.active]: s.key === selected.key,
                  [classIconInactive || '']: s.key !== selected.key,
                })}
              >
                {s.icon}
              </span>
              <span className={styles.iconHeading}>{s.key}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default IcnStyleSwitcher
